import {
  CLEAR_FORM_LANGUAGE_RESTRICTION,
  CLEAR_FORM_LANGUAGE_RESTRICTION_ONLY,
  FormRestrictionsAction,
  SET_FORM_LANGUAGE_RESTRICTION
} from '../actions/FormRestrictionsActions'

interface FormRestrictionsState {
  allowedLanguages: string[] | null
  /** Language to restore when the restriction lifecycle ends. First write wins — never overwritten mid-lifecycle. */
  originalLanguage: string | null
}

const initialState: FormRestrictionsState = {
  allowedLanguages: null,
  originalLanguage: null
}

const FormRestrictionsReducer = (
  state: FormRestrictionsState = initialState,
  action: FormRestrictionsAction
): FormRestrictionsState => {
  switch (action.type) {
    case SET_FORM_LANGUAGE_RESTRICTION:
      return {
        ...state,
        allowedLanguages: action.data,
        originalLanguage: state.originalLanguage ?? action.originalLanguage ?? null
      }
    case CLEAR_FORM_LANGUAGE_RESTRICTION_ONLY:
      return { ...state, allowedLanguages: null }
    case CLEAR_FORM_LANGUAGE_RESTRICTION:
      return { allowedLanguages: null, originalLanguage: null }
    default:
      return state
  }
}

export default FormRestrictionsReducer
